import { getHeight, getWidth } from 'ol/extent';
import { PROJECTIONS as WEB_MERCATOR_PROJECTIONS } from 'ol/proj/epsg3857';
import Projection from 'ol/proj/Projection';

import { assert } from 'cadenza/utils/custom-error';

const WEB_MERCATOR_PROJECTION_CODES = WEB_MERCATOR_PROJECTIONS.map(proj => proj.getCode());

export function isWebMercatorProjection (projection) {
  return WEB_MERCATOR_PROJECTION_CODES.includes(projection.getCode());
}

export function getWebMercatorMaxResolution () {
  return maxResolutionFromExtent(WEB_MERCATOR_PROJECTIONS[0].getExtent());
}

/**
 * Creates max resolution from an extent. Inspired by OL function ol/tilegrid~resolutionsFromExtent.
 *
 * @param extent - Extent
 * @param [tileSize] - Tile size
 * @param tileSize.tileWidth
 * @param tileSize.tileHeight
 * @return maximal resolution
 */
function maxResolutionFromExtent (extent, { tileWidth = 256, tileHeight = 256 } = {}) {
  assert(extent, 'extent is mandatory');
  const height = getHeight(extent);
  const width = getWidth(extent);
  return Math.max(width / tileWidth, height / tileHeight);
}

export function cloneProjection (projection, {
  code = projection.getCode(),
  units = projection.getUnits(),
  extent = projection.getExtent(),
  axisOrientation = projection.getAxisOrientation(),
  global = projection.isGlobal(),
  metersPerUnit = projection.getMetersPerUnit(),
  worldExtent = projection.getWorldExtent(),
  getPointResolution = projection.getPointResolutionFunc()
}) {
  return new Projection({
    code,
    units,
    extent,
    axisOrientation,
    global,
    metersPerUnit,
    worldExtent,
    getPointResolution
  });
}
